import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from 'src/libs/angular/core/src/lib/environments/environment';

@Component({
  selector: 'aa-about-section',
  standalone: true,
  imports: [],
  templateUrl: './about-section.component.html',
  styleUrl: './about-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutSectionComponent {
  customerAppURLBase = environment.customerAppURL;
}
